module.exports = __webpack_public_path__ + "img/Portería.26fcc832.svg";